module.exports = __webpack_public_path__ + "static/single-32a727ecf2212d53dd96a2f7f872fd2d.png";